/* PQ flip-clock countdown. Reads data-end as Sydney local time "YYYY-MM-DD HH:MM". Updates every second; flips changed digits. */
(function(){
  'use strict';
  var SYD='Australia/Sydney';
  function sydOffsetMs(utcMs){ // offset of Sydney from UTC at the given instant (handles daylight saving)
    var parts=new Intl.DateTimeFormat('en-US',{timeZone:SYD,hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'}).formatToParts(new Date(utcMs));
    var o={};parts.forEach(function(p){o[p.type]=p.value});
    return Date.UTC(+o.year,+o.month-1,+o.day,+o.hour,+o.minute,+o.second)-utcMs;
  }
  function parseSydney(s){ // "YYYY-MM-DD HH:MM" in Sydney -> epoch ms
    var m=/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/.exec((s||'').trim()); if(!m) return NaN;
    var naive=Date.UTC(+m[1],+m[2]-1,+m[3],m[4]?+m[4]:23,m[5]?+m[5]:59,59);
    var guess=naive-sydOffsetMs(naive); return naive-sydOffsetMs(guess);
  }
  function setDigit(el,ch){
    var top=el.children[0],bottom=el.children[1],ft=el.children[2],fb=el.children[3];
    if(top.textContent===ch){return}
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){top.textContent=bottom.textContent=ft.textContent=fb.textContent=ch;return}
    ft.textContent=top.textContent; fb.textContent=ch; top.textContent=ch;
    el.classList.remove('is-flipping'); void el.offsetWidth; el.classList.add('is-flipping');
    setTimeout(function(){bottom.textContent=ch;ft.textContent=ch;el.classList.remove('is-flipping')},620);
  }
  function pad(n){n=Math.max(0,Math.floor(n));return (n<10?'0':'')+n}
  function init(root){
    var end=parseSydney(root.getAttribute('data-end')); if(isNaN(end)){root.hidden=true;return}
    var groups=root.querySelectorAll('.pq-sf-flip__group'),sr=root.querySelector('[data-pq-sf-flip-sr]'),lastSr=0;
    function tick(){
      var left=end-Date.now();
      if(left<=0){root.classList.add('is-ended');if(sr)sr.textContent=root.getAttribute('data-ended')||'';return false}
      var s=Math.floor(left/1000),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),sec=s%60;
      var vals=[d>99?'99':pad(d),pad(h),pad(m),pad(sec)];
      for(var i=0;i<groups.length;i++){var ds=groups[i].querySelectorAll('[data-d]');setDigit(ds[0],vals[i][0]);setDigit(ds[1],vals[i][1])}
      if(sr&&Date.now()-lastSr>60000){lastSr=Date.now();sr.textContent=d+' days '+h+' hours '+m+' minutes remaining'}
      return true;
    }
    if(tick()){var id=setInterval(function(){if(!tick())clearInterval(id)},1000)}
  }
  function boot(){var els=document.querySelectorAll('[data-pq-sf-flip]');for(var i=0;i<els.length;i++){if(!els[i].__pq){els[i].__pq=1;init(els[i])}}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
